import React from "react"
import { StyleSheet } from "react-native"
import { useStyle } from "react-native-style-utilities"

import type { BoxProps } from "./Box"

import { Box } from "./Box"
import { SPACING } from "./theme/spacing"

const styles = StyleSheet.create({
  root: {
    display: "flex",
    flexDirection: "row",
  },
})

export interface RowProps extends BoxProps {
  _items?: BoxProps
  /** Vertical gap between wrapped lines. `space` only adds horizontal
   * margins, so wrapped rows sit flush without this. Opt-in — some call
   * sites already add vertical margins on their children. */
  rowGap?: "$1" | "$2" | "$3" | "$4"
  space?: "$1" | "$2" | "$3" | "$4"
}

// TODO: This space thing doesn't seem to be working right (horizontal
// margins double up between adjacent children). Vertical spacing between
// wrapped lines is handled by the `rowGap` prop.
export function Row({
  _items,
  alignItems = "center",
  children,
  flexWrap = "wrap",
  justifyContent = "flex-start",
  rowGap,
  space,
  style,
  ...rest
}: RowProps) {
  const numChildren = React.Children.count(children) - 1
  let isChildRendered = false
  return (
    <Box
      style={useStyle(() => {
        return [
          styles.root,
          {
            alignItems,
            flexWrap,
            justifyContent,
            ...(rowGap ? { rowGap: SPACING[rowGap] } : null),
          },
          style,
        ]
      }, [alignItems, flexWrap, justifyContent, rowGap, style])}
      {...rest}
    >
      {space
        ? React.Children.map(children, (child, index) => {
            if (child === null) {
              return child
            }
            if (!isChildRendered) {
              isChildRendered = true
              return (
                <Box {..._items} key={index} mr={space}>
                  {child}
                </Box>
              )
            }
            if (index === numChildren) {
              return (
                <Box {..._items} key={index} ml={space}>
                  {child}
                </Box>
              )
            }
            return (
              <Box {..._items} key={index} mx={space}>
                {child}
              </Box>
            )
          })
        : children}
    </Box>
  )
}
